export default __webpack_public_path__ + "static/media/LogotipoHygra.8510af1e.svg";